import React from "react";

import { Button, useTheme } from "react-native-paper";

type Props = {
  text: string;
  icon: string;
  onPress: () => void;
};

export default function TextIconButton({ text, icon, onPress }: Props) {
  const { colors } = useTheme();
  return (
    <Button
      mode="text"
      icon={icon}
      onPress={onPress}
      textColor={colors.onSurface}
    >
      {text}
    </Button>
  );
}
